import axios from 'axios';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.management_api.storage_units;

// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// Cached API wrapper for this namespace/group
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'management_api',
  group: 'storage_units',
  defaultTtl: '5m',
  hashLargeSegments: true,
  emitMeta: true,
});

// /GetAllStorageUnits
export const getAllStorageUnits = async () => {
  return await retryWithBackoff(() => cachedApi.get('/GetAllStorageUnits'));
};

// /GetStorageUnitsByCompanyId/<int:company_id>
export const getStorageUnitsByCompanyId = async (companyId: number) => {
  return await retryWithBackoff(() => cachedApi.get(`/GetStorageUnitsByCompanyId/${companyId}`));
};

// /GetStorageUnitsByLocalId/<int:local_id>
export const getStorageUnitsByLocalId = async (localId: number) => {
  return await retryWithBackoff(() => cachedApi.get(`/GetStorageUnitsByLocalId/${localId}`));
};

// /GetStorageUnitById/<int:storage_unit_id>
export const getStorageUnitById = async (storageUnitId: number) => {
  return await retryWithBackoff(() => cachedApi.get(`/GetStorageUnitById/${storageUnitId}`));
};

// /CreateStorageUnit and example payload:
// {
//   "local_id": 1,
//   "is_global": true,
//   "name": "Almacén Central",
//   "capacity": 1000,
//   "priority": 1,
//   "backup_storage_unit_id": 2,
//   "storage_unit_metadata": { "temperature_controlled": true }
// }
export const createStorageUnit = async (payload: any) => {
  const res = await retryWithBackoff(() => api.post('/CreateStorageUnit', payload));
  await cachedApi.clear();
  return res;
};

// /UpdateStorageUnit/<int:storage_unit_id> and example payload:
// {
//   "name": "Almacén Principal",
//   "capacity": 1200,
//   "priority": 2,
//   "backup_storage_unit_id": 3,
//   "storage_unit_metadata": { "temperature_controlled": false }
// }
export const updateStorageUnit = async (storageUnitId: number, payload: any) => {
  const res = await retryWithBackoff(() => api.put(`/UpdateStorageUnit/${storageUnitId}`, payload));
  await cachedApi.clear();
  return res;
};

// /DeleteStorageUnit/<int:storage_unit_id>
export const deleteStorageUnit = async (storageUnitId: number) => {
  const res = await retryWithBackoff(() => api.delete(`/DeleteStorageUnit/${storageUnitId}`));
  await cachedApi.clear();
  return res;
};

export const initStorageUnitsDefaultByLocalId = async (localId: number) => {
  const res = await retryWithBackoff(() => api.post(`/InitStorageUnitsDefaultByLocalId/${localId}`, {}));
  await cachedApi.clear();
  return res;
};